module.exports = __webpack_public_path__ + "img/banner_home.91abe40f.jpg";